import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { CONTRACT_TYPE } from '@avanta/shared/constants/psychologists';
import { formatDateSimple } from '@avanta/shared/utils/date';
import { useTranslation } from 'react-i18next';
import { useUserStore } from 'stores/user';

export const PsychologistBalance = (): React.ReactElement | null => {
  const user = useUserStore(state => state.user);
  const isPsychologist = useUserStore(state => state.isPsychologist);
  const { t } = useTranslation(LOCIZE_NS.PROFILE);

  if (!isPsychologist || user?.contractType !== CONTRACT_TYPE.FREELANCE || !user?.lastPaymentDate) {
    return null;
  }

  return (
    <Card className="bg-white" title={t('PsychologistBalance.heading')}>
      <div>
        {t('PsychologistBalance.body', {
          value: user?.balance,
          date: formatDateSimple(user?.lastPaymentDate),
        })}
      </div>
    </Card>
  );
};
